<app-smart-input-entity2
  fieldLabel="label"
  [control]="control()"
  [handler]="enumPickerHandler()"
  [placeholder]="placeholder()"
  [resetValue]="resetValue() ?? undefined">
  <ng-template
    let-item="item"
    appTemplate>
    @if (cast(item); as item) {
      <div class="flex flex-row items-center gap-3">
        <!-- @if (item.icon) {
          <svg-icon
            [size]="'lg'"
            [key]="item.icon"></svg-icon>
        } -->
        <span>{{ labels()?.[item] ?? item }}</span>
      </div>
    }
  </ng-template>
</app-smart-input-entity2>
